import { gql } from '@apollo/client';

export const GET_LOCATION_QUERY = gql`
  query GetLocation($id: uuid!) {
    locations_by_pk(id: $id) {
      id
      name
      address
      school_contact
      school_email
      phone
      location_type
    }
  }
`;
